import { CALL_API } from '../middleware/api'

// «Clientes · ID» (ADMIN MASTER): Waterproof customers against auth / Lockers and the change of a customer's id to its
// auth id. Every call resolves to { type, response } or { type, error }; the view keeps the data in local state.

export const CUSTOMER_IDS_REQUEST = 'CUSTOMER_IDS_REQUEST'
export const CUSTOMER_IDS_SUCCESS = 'CUSTOMER_IDS_SUCCESS'
export const CUSTOMER_IDS_FAILURE = 'CUSTOMER_IDS_FAILURE'

const TYPES = [CUSTOMER_IDS_REQUEST, CUSTOMER_IDS_SUCCESS, CUSTOMER_IDS_FAILURE]

const call = (method, endpoint, body) => ({
  [CALL_API]: { method, endpoint, authenticated: true, types: TYPES, ...(body ? { body: JSON.stringify(body) } : {}) }
})

export const fetchCustomerIds = () => call('GET', 'customer-ids')
export const adoptCustomerAuthEmail = (id, authId) => call('POST', `customer-ids/${id}/email`, { authId })
export const previewCustomerId = (id, target) => call('GET', `customer-ids/${id}/preview?target=${encodeURIComponent(target)}`)
export const migrateCustomerId = (id, target, confirm) => call('POST', `customer-ids/${id}/migrate`, { target, confirm })
export const fetchCustomerIdJournal = () => call('GET', 'customer-ids/journal')
export const fetchCustomerIdChange = (journalId) => call('GET', `customer-ids/journal/${journalId}`)
export const resumeCustomerIdChange = (journalId) => call('POST', `customer-ids/journal/${journalId}/resume`, {})
export const abortCustomerIdChange = (journalId) => call('POST', `customer-ids/journal/${journalId}/abort`, {})
export const undoCustomerIdChange = (journalId) => call('POST', `customer-ids/journal/${journalId}/undo`, {})
export const sweepCustomerIds = () => call('POST', 'customer-ids/sweep', {})
